import IssueList from './IssueList';

export default IssueList;
